import { render, staticRenderFns } from "./adult-sell-order-handle-table.vue?vue&type=template&id=7252d7b3&"
import script from "./adult-sell-order-handle-table.vue?vue&type=script&lang=js&"
export * from "./adult-sell-order-handle-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports